import PropTypes from "prop-types";
export default {
  logEvent: PropTypes.func,
  setLogger: PropTypes.func,
  setContext: PropTypes.func,
  setLocalContext: PropTypes.func,
  setInterfaceId: PropTypes.func,
  getInterfaceId: PropTypes.func
};